import { useMemo } from 'react';
import { FormField } from '@src/components/SmartDataTable/types';
import { MANUFACTURER_STATUS_OPTIONS } from '../constants';
import { getPhoneFieldConfig } from '@src/utils/phoneUtils';

export const useManufacturersFormFields = (): FormField[] => {
  // Convert readonly options to mutable array
  const statusOptions = MANUFACTURER_STATUS_OPTIONS.map(opt => ({
    label: opt.label,
    value: opt.value,
  }));

  return useMemo(
    () => [
      // Row 1
      // {
      //   name: 'manufacturer',
      //   label: 'Manufacturer Name',
      //   type: 'text',
      //   required: true,
      //   placeholder: 'Enter manufacturer name',
      //   rules: [
      //     { required: true, message: 'Please enter manufacturer name' },
      //     { max: 30, message: 'Name cannot exceed 30 characters' },
      //   ],
      //   layout: { span: 12 },
      // },
      {
        name: 'contact_person',
        label: 'Contact Person',
        type: 'text',
        required: true,
        placeholder: 'Enter contact person name',
        rules: [
          { required: true, message: 'Please enter contact person name' },
          {
            max: 30,
            message: 'Contact person name cannot exceed 30 characters',
          },
        ],
        layout: { span: 12 },
      },
      // Row 2
      {
        name: 'phone',
        label: 'Phone',
        ...getPhoneFieldConfig(true, '98765 43210'),
        props: {
          ...getPhoneFieldConfig().props,
          size: 'middle',
          className: 'compact-phone-field',
        },
        rules: [{ required: true, message: 'Please enter phone number' }],
        layout: { span: 12 },
        tooltip: 'Enter 10-digit mobile number (without country code)',
      },
    ],
    [statusOptions]
  );
};
